// Colour palette for departments — used on the Shift Codes editor and in the
// grouped Day Timeline view.  Each entry has a solid dot colour, a soft strip
// background for the count row, and a strong text colour for the group label.
export const DEPT_COLORS = [
  { id: "red",     label: "Red",     dot: "bg-red-500",     strip: "bg-red-50",     text: "text-red-800",     border: "border-red-200",     ring: "ring-red-400" },
  { id: "orange",  label: "Orange",  dot: "bg-orange-500",  strip: "bg-orange-50",  text: "text-orange-800",  border: "border-orange-200",  ring: "ring-orange-400" },
  { id: "amber",   label: "Amber",   dot: "bg-amber-500",   strip: "bg-amber-50",   text: "text-amber-800",   border: "border-amber-200",   ring: "ring-amber-400" },
  { id: "emerald", label: "Emerald", dot: "bg-emerald-500", strip: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200", ring: "ring-emerald-400" },
  { id: "teal",    label: "Teal",    dot: "bg-teal-500",    strip: "bg-teal-50",    text: "text-teal-800",    border: "border-teal-200",    ring: "ring-teal-400" },
  { id: "cyan",    label: "Cyan",    dot: "bg-cyan-500",    strip: "bg-cyan-50",    text: "text-cyan-800",    border: "border-cyan-200",    ring: "ring-cyan-400" },
  { id: "blue",    label: "Blue",    dot: "bg-blue-500",    strip: "bg-blue-50",    text: "text-blue-800",    border: "border-blue-200",    ring: "ring-blue-400" },
  { id: "indigo",  label: "Indigo",  dot: "bg-indigo-500",  strip: "bg-indigo-50",  text: "text-indigo-800",  border: "border-indigo-200",  ring: "ring-indigo-400" },
  { id: "violet",  label: "Violet",  dot: "bg-violet-500",  strip: "bg-violet-50",  text: "text-violet-800",  border: "border-violet-200",  ring: "ring-violet-400" },
  { id: "pink",    label: "Pink",    dot: "bg-pink-500",    strip: "bg-pink-50",    text: "text-pink-800",    border: "border-pink-200",    ring: "ring-pink-400" },
  { id: "slate",   label: "Slate",   dot: "bg-slate-500",   strip: "bg-slate-50",   text: "text-slate-800",   border: "border-slate-200",   ring: "ring-slate-400" },
];

const UNASSIGNED = { id: "unassigned", label: "Unassigned", dot: "bg-slate-300", strip: "bg-slate-50", text: "text-slate-600", border: "border-slate-200", ring: "ring-slate-300" };

export const UNASSIGNED_LABEL = "Unassigned";

export function deptColor(id) {
  if (!id) return UNASSIGNED;
  return DEPT_COLORS.find(d => d.id === id) || UNASSIGNED;
}

// Deterministic fallback: if a department name has no explicit colour, hash to
// one from the palette so it still stays consistent across the app.
export function deptColorFor(name, explicit) {
  if (explicit) return deptColor(explicit);
  if (!name) return UNASSIGNED;
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return DEPT_COLORS[h % DEPT_COLORS.length];
}
